import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { REVEAL_CODEX_SECRET } from '@/graphql/mutations/connections';

type UseRevealCodexSecretResult = {
  revealCodexSecret: () => Promise<string | null>;
  isRevealing: boolean;
};

/** The full signing secret, fetched only when someone copies it; it is never kept in the cache. */
export function useRevealCodexSecret(): UseRevealCodexSecretResult {
  const [mutate, { loading }] = useMutation(REVEAL_CODEX_SECRET, { fetchPolicy: 'no-cache' });

  const revealCodexSecret = useCallback(async () => {
    const { data } = await mutate();
    return data?.revealCodexSecret.secret ?? null;
  }, [mutate]);

  return { revealCodexSecret, isRevealing: loading };
}
